export interface GallerySlide {
  src: string
  alt: string
}

export const insideItems: string[] = [
  'Top-down vehicle diagrams',
  'Road layouts',
  'Vehicle trajectories',
  'Steering direction',
  'Mirror and observation systems',
  'Parking sequences',
  'Reversing diagrams',
  'Junction layouts',
  'Roundabout visuals',
  'Lane positioning',
  'Correct-vs-incorrect comparisons',
  'Common student mistakes',
  'Quick corrections',
  'Instructor cue cards',
  'Progression maps',
  'Assessments',
  'Checklists',
  'Quick-reference tools',
]

export const gallerySlides: GallerySlide[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/nqVhaKyJ8sHWT9QJXHu21k/Captura_de_pantalla_2026-10-05_201246.png',
    alt: 'Page preview 1 from Driving Instructor Ready',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jmMazX6Ds1JTC3LHp9qAXe/Captura_de_pantalla_2026-10-05_201224.png',
    alt: 'Page preview 2 from Driving Instructor Ready',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jR9A1wyErJHa9HqyteK1Ja/Captura_de_pantalla_2026-10-05_201200.png',
    alt: 'Page preview 3 from Driving Instructor Ready',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dAr8VQQJo8dFdXuvYkdASs/Captura_de_pantalla_2026-10-05_201140.png',
    alt: 'Page preview 4 from Driving Instructor Ready',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/egrGbhGyuteQKKAuws8FLx/Captura_de_pantalla_2026-10-05_201119.png',
    alt: 'Page preview 5 from Driving Instructor Ready',
  },
]
